import { DeferredPage } from "@/components/data-display/deferred-page";

// Deferred (page-delivery-pipeline.md G6, 2026-09-23). No staking backend exists in this
// environment: validator uptime, commission, delegation totals, and slashing/audit history
// were previously fabricated. See context/page_pipeline/BOARD.md wave 4 and
// context/page_pipeline/BACKEND_GAPS.md.
export default function TreasuryStakingValidatorPage() {
  return (
    <DeferredPage
      nav={{ kind: "breadcrumb", parents: [{ label: "Treasury", href: "/treasury" }, { label: "Staking Positions", href: "/treasury/staking" }], label: "Validator Detail" }}
      state={{
        title: "Validator detail is not available in this environment yet",
        description: "Validator performance, uptime, commission, and audit history have no backend in this environment yet. This page will show real validator data once the staking domain is built.",
      }}
    />
  );
}
